var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb } from '@airtel/air-design-system';
import { View } from 'react-native';
export var BreadcrumbWidgetComponent = props => {
  var data = props.data,
    maxDisplayedItems = props.maxDisplayedItems,
    overflowIndex = props.overflowIndex,
    id = props.id,
    onUserAction = props.onUserAction,
    onPress = props.onPress,
    restProps = __rest(props, ["data", "maxDisplayedItems", "overflowIndex", "id", "onUserAction", "onPress"]);
  return _jsx(View, Object.assign({}, restProps, {
    children: !!data && _jsx(Breadcrumb, {
      maxDisplayedItems: maxDisplayedItems,
      overflowIndex: overflowIndex,
      onClickHandler: (_e, data) => {
        onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onPress), data));
      },
      data: data
    })
  }));
};
BreadcrumbWidgetComponent.genericRendererKey = 'AirBreadcrumbWidget';
BreadcrumbWidgetComponent.defaultProps = {
  showSpacer: true,
  spacerProps: {
    top: {
      mobile: 'SPACING_20',
      desktop: 'SPACING_20'
    },
    bottom: {
      mobile: 'SPACING_20',
      desktop: 'SPACING_24'
    }
  }
};